@if (title || description) {
  <ion-item
    [id]="uid"
    [lines]="lines"
    [button]="!operations?.length ? false : button"
    [class]="className"
    (click)="handleAction()"
    #component
  >
    @if (icon && lines !== 'inset') {
      <div
        class="dcf-icon-container dcf-width-auto"
        [slot]="iconSlot"
      >
        <ngx-decaf-icon
          slot="icon-only"
          [name]="icon"
        />
      </div>
    }
    <div class="dcf-width-expand">
      <div
        class="dcf-flex dcf-flex-middle dcf-grid-collapse"
        dcf-grid
      >
        @if (icon && lines === 'inset') {
          <div
            class="dcf-icon"
            [slot]="iconSlot"
          >
            <ion-avatar>
              <span class="ti ti-file-text"></span>
            </ion-avatar>
          </div>
        }
        <div class="dcf-width-expand@s dcf-width-1-1 dcf-label">
          @if (title) {
            <ion-label>
              <span [innerHTML]="title | translate"></span>
            </ion-label>
          }
          @if (description) {
            <div
              class="dcf-description"
              [innerHTML]="description"
            ></div>
          }
        </div>

        @if (this.operation !== OperationKeys.READ && isEpiWriter) {
          <div class="dcf-width-auto dcf-flex dcf-flex-middle dcf-flex-right">
            <ngx-decaf-icon
              slot="icon-only"
              name="ti-trash"
              color="danger"
              (click)="handleDelete($event)"
            />
          </div>
        }
      </div>
    </div>
  </ion-item>
}
